import { ServerWideExternalReplication } from "../../ServerWide/Operations/OngoingTasks/ServerWideExternalReplication.js";

export interface GetServerWideExternalReplicationsResponse {
    results: ServerWideExternalReplication[];
}